import { createTRPCReact, httpBatchLink } from "@trpc/react-query"
import { createTRPCClient as createVanillaClient, httpLink } from "@trpc/client"
import type { AppRouter } from "@ai-tutor/server/trpc/router"
import { API_HOST, STORAGE_KEY } from "./config"

export const trpc = createTRPCReact<AppRouter>()

export function createTRPCClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${API_HOST}/trpc`,
        headers() {
          const token = localStorage.getItem(STORAGE_KEY)
          return token ? { Authorization: `Bearer ${token}` } : {}
        },
      }),
    ],
  })
}

/** Vanilla tRPC client for use outside React components (e.g. Zustand stores) */
export const vanillaClient = createVanillaClient<AppRouter>({
  links: [
    httpLink({
      url: `${API_HOST}/trpc`,
      headers() {
        const token = localStorage.getItem(STORAGE_KEY)
        return token ? { Authorization: `Bearer ${token}` } : {}
      },
    }),
  ],
})
